import { jsx as _jsx } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { Award, ClipboardList, FileText, Flag, GitBranch, Handshake, Layers, LayoutDashboard, Lightbulb, ListChecks, MessagesSquare, Network, PackageCheck, Scale, SquareCheck, Target, Users } from 'lucide-react';
const icon = 'h-4 w-4 flex-shrink-0';
/** §4.1 pursuit registry (base `/capture/:id`). The contract FND-18 renders and GRW builds routes for. */ export const PURSUIT_NAV_GROUPS = [
    {
        id: 'top',
        items: [
            {
                id: 'home',
                label: 'Home',
                path: '',
                icon: /*#__PURE__*/ _jsx(LayoutDashboard, {
                    className: icon
                })
            },
            {
                id: 'chat',
                label: 'Chat',
                path: 'chat',
                icon: /*#__PURE__*/ _jsx(MessagesSquare, {
                    className: icon
                })
            }
        ]
    },
    {
        id: 'shaping',
        label: 'Shaping',
        items: [
            {
                id: 'customer',
                label: 'Customer & touchpoints',
                path: 'customer',
                icon: /*#__PURE__*/ _jsx(Users, {
                    className: icon
                }),
                testId: Testids.capture.tabInteractions,
                countKey: 'touchpoints',
                countLabel: 'touchpoints'
            },
            {
                id: 'competitors',
                label: 'Competitors',
                path: 'competitors',
                icon: /*#__PURE__*/ _jsx(Flag, {
                    className: icon
                }),
                countKey: 'competition',
                countLabel: 'competitors'
            },
            {
                id: 'black-hat',
                label: 'Black hat',
                path: 'black-hat',
                icon: /*#__PURE__*/ _jsx(Scale, {
                    className: icon
                })
            },
            {
                id: 'win-themes',
                label: 'Win themes',
                path: 'win-themes',
                icon: /*#__PURE__*/ _jsx(Target, {
                    className: icon
                }),
                countKey: 'win_themes',
                countLabel: 'win themes'
            },
            {
                id: 'teaming',
                label: 'Teaming',
                path: 'teaming',
                icon: /*#__PURE__*/ _jsx(Handshake, {
                    className: icon
                }),
                countKey: 'teaming',
                countLabel: 'teaming partners'
            }
        ]
    },
    {
        id: 'workspaces',
        label: 'Workspaces',
        items: [
            {
                id: 'rfi-responses',
                label: 'RFI responses',
                path: 'rfi-responses',
                icon: /*#__PURE__*/ _jsx(ListChecks, {
                    className: icon
                }),
                testId: Testids.capture.tabRfis,
                countKey: 'rfi_responses',
                countLabel: 'RFI responses'
            },
            {
                id: 'proposal',
                label: 'Proposal',
                path: 'proposal',
                icon: /*#__PURE__*/ _jsx(FileText, {
                    className: icon
                })
            }
        ]
    },
    {
        id: 'decisions',
        label: 'Decisions',
        items: [
            {
                id: 'decisions',
                label: 'Go / no-go',
                path: 'decisions',
                icon: /*#__PURE__*/ _jsx(SquareCheck, {
                    className: icon
                }),
                countKey: 'go_no_go',
                countLabel: 'decisions'
            },
            {
                id: 'surgery',
                label: 'Splits & merges',
                path: 'surgery',
                icon: /*#__PURE__*/ _jsx(GitBranch, {
                    className: icon
                }),
                countKey: 'surgery',
                countLabel: 'splits and merges'
            }
        ]
    },
    {
        id: 'documents',
        label: 'Documents',
        items: [
            {
                id: 'documents',
                label: 'Docs',
                path: 'documents',
                icon: /*#__PURE__*/ _jsx(FileText, {
                    className: icon
                }),
                testId: Testids.capture.tabDocuments,
                countKey: 'docs',
                countLabel: 'documents'
            }
        ]
    },
    // GRW-15 (§3.3): keeps the profile/plan panels, solution, outputs, past
    // performance, workstreams and the knowledge graph reachable, collapsed by
    // default (OD-05). Items that replace a legacy tab keep its testid.
    {
        id: 'working',
        label: 'Working papers',
        defaultOpen: false,
        items: [
            {
                id: 'plan',
                label: 'Profile & plan',
                path: 'plan',
                icon: /*#__PURE__*/ _jsx(ClipboardList, {
                    className: icon
                }),
                testId: Testids.capture.tabOverview
            },
            {
                id: 'solution',
                label: 'Solution',
                path: 'solution',
                icon: /*#__PURE__*/ _jsx(Lightbulb, {
                    className: icon
                }),
                testId: Testids.captureSolution.tab
            },
            {
                id: 'outputs',
                label: 'Outputs',
                path: 'outputs',
                icon: /*#__PURE__*/ _jsx(PackageCheck, {
                    className: icon
                }),
                testId: Testids.captureOutputs.tab
            },
            {
                id: 'past-performance',
                label: 'Past performance',
                path: 'past-performance',
                icon: /*#__PURE__*/ _jsx(Award, {
                    className: icon
                }),
                testId: Testids.pursuitPP.tab
            },
            {
                id: 'workstreams',
                label: 'Workstreams',
                path: 'workstreams',
                icon: /*#__PURE__*/ _jsx(Layers, {
                    className: icon
                }),
                testId: Testids.capture.tabWorkstreams
            },
            {
                id: 'graph',
                label: 'Knowledge graph',
                path: 'graph',
                icon: /*#__PURE__*/ _jsx(Network, {
                    className: icon
                })
            }
        ]
    }
];
/** Last breadcrumb per section slug ('' = record home). */ export const PURSUIT_SECTION_LABELS = {
    '': 'Home',
    chat: 'Chat',
    customer: 'Customer & touchpoints',
    competitors: 'Competitors',
    'black-hat': 'Black hat',
    'win-themes': 'Win themes',
    teaming: 'Teaming',
    'rfi-responses': 'RFI responses',
    proposal: 'Proposal',
    decisions: 'Go / no-go',
    surgery: 'Splits & merges',
    documents: 'Docs',
    plan: 'Profile & plan',
    solution: 'Solution',
    outputs: 'Outputs',
    'past-performance': 'Past performance',
    workstreams: 'Workstreams',
    graph: 'Knowledge graph'
};
